
import { defineComponent, onMounted, ref, onBeforeUnmount } from 'vue';
import anime from 'animejs';
import GradientPath from 'gradient-path';

export default defineComponent({
  name: 'Gauge',
  setup() {
    const gaugeFillPath = ref();
    const isForward = ref(true);
    const percentComplete = ref(0);
    const gaugeAnimation = ref();

    onMounted(() => {
      const gp = new GradientPath({
        path: gaugeFillPath.value,
        segments: 15,
        samples: 10,
        precision: 10
      });

      const colors = [
        { color: 'rgba(193, 34, 195, 1)', pos: 0 },
        { color: 'rgba(255, 234, 67, 1)', pos: 0.5 },
        { color: 'rgba(193, 34, 195, 1)', pos: 1 }
      ];

      gp.render({
        type: 'circle',
        stroke: colors,
        fill: colors,
        strokeWidth: 1,
        width: 25
      });

      const animation = (direction: string) => {
        gaugeAnimation.value = anime({
          targets: document.querySelectorAll('.gauge-fill .circle-sample'),
          opacity: [0, 1],
          easing: 'easeInOutSine',
          duration: 1,
          direction,
          delay: anime.stagger(20),
          update: anim => {
            percentComplete.value = Math.round(anim.progress);
          },
          complete: () => {
            setTimeout(() => {
              isForward.value = !isForward.value;
              animation(isForward.value ? 'normal' : 'reverse');
            }, 1000);
          }
        });
      };

      animation('normal');
    });

    onBeforeUnmount(() => {
      gaugeAnimation.value.remove(document.querySelectorAll('.gauge-fill .circle-sample'));
    });

    return {
      gaugeFillPath,
      percentComplete
    };
  }
});
